import { render, staticRenderFns } from "./LogEmailActivity.vue?vue&type=template&id=25a95797&"
import script from "./LogEmailActivity.vue?vue&type=script&lang=js&"
export * from "./LogEmailActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports